import { useI18n } from '../../i18n.js';

export function LandingHowToPlay() {
  const { t } = useI18n();

  return (
    <section className="landing-section" id="how-to-play" aria-label={t.landingStepsTitle}>
      <div className="landing-section-header">
        <h2>{t.landingStepsTitle}</h2>
        <p>{t.landingStepsSubtitle}</p>
      </div>

      <div className="steps-grid">
        <div className="step-card">
          <div className="step-header">
            <span className="step-num">01</span>
            <span className="step-rule" aria-hidden="true" />
          </div>
          <h3 className="step-title">{t.landingStep1Title}</h3>
          <p className="step-desc">{t.landingStep1Desc}</p>
        </div>

        <div className="step-card">
          <div className="step-header">
            <span className="step-num">02</span>
            <span className="step-rule" aria-hidden="true" />
          </div>
          <h3 className="step-title">{t.landingStep2Title}</h3>
          <p className="step-desc">{t.landingStep2Desc}</p>
        </div>

        <div className="step-card">
          <div className="step-header">
            <span className="step-num">03</span>
            <span className="step-rule" aria-hidden="true" />
          </div>
          <h3 className="step-title">{t.landingStep3Title}</h3>
          <p className="step-desc">{t.landingStep3Desc}</p>
        </div>
      </div>
    </section>
  );
}
